// @core/api/endpoints/workflow/delete_agent_tool.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/workflow';

/**
 * Delete agent tool
 * Deletes an agent tool. Builtin tools cannot be deleted. Agent nodes referencing it fail at run time with an error naming the missing tool.
 */
export async function DeleteAgentTool(
  tool_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/agent-tools/:tool_id`;
  requestPath = requestPath.replace(':tool_id', encodeURIComponent(tool_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
